export type BlockType = 'article' | 'image' | 'ad' | 'title' | 'divider' | 'quote';

export interface LayoutBlock {
  id: string;
  type: BlockType;
  x: number;
  y: number;
  w: number;
  h: number;
  content: {
    title?: string;
    body?: string;
    author?: string;
    section?: string;
    imageUrl?: string;
    caption?: string;
    adName?: string;
    adClient?: string;
    priority?: 'high' | 'medium' | 'low';
    style?: 'headline' | 'body' | 'caption' | 'subheadline';
  };
  locked?: boolean;
  selected?: boolean;
}

export interface EditorPage {
  id: string;
  number: number;
  type: 'capa' | 'interna' | 'contracapa';
  section: string;
  blocks: LayoutBlock[];
  status: 'rascunho' | 'revisão' | 'aprovado';
}

export const mockEditorPages: EditorPage[] = [
  {
    id: 'page-1',
    number: 1,
    type: 'capa',
    section: 'Capa',
    status: 'revisão',
    blocks: [
      {
        id: 'b1',
        type: 'title',
        x: 0, y: 0, w: 12, h: 2,
        content: {
          title: 'JARDEL CITY POST',
          style: 'headline',
        },
      },
      {
        id: 'b2',
        type: 'image',
        x: 0, y: 2, w: 8, h: 10,
        content: {
          imageUrl: 'https://public.readdy.ai/ai/img_res/78044bf3dcc0266f0d9045418b12ed7f.jpg',
          caption: 'Vista aérea do centro de Jardel City',
        },
      },
      {
        id: 'b3',
        type: 'article',
        x: 8, y: 2, w: 4, h: 6,
        content: {
          title: 'Prefeitura anuncia plano de mobilidade urbana para 2026',
          body: 'A administração municipal apresentou um ambicioso projeto de reestruturação do transporte público, com investimentos de R$ 2,4 bilhões previstos para os próximos três anos.',
          author: 'Carlos Mendes',
          section: 'Política',
          priority: 'high',
          style: 'headline',
        },
      },
      {
        id: 'b4',
        type: 'article',
        x: 8, y: 8, w: 4, h: 4,
        content: {
          title: 'Startup local levanta R$ 15 milhões em rodada série A',
          body: 'A fintech jardel-cityense Credix fechou rodada de investimento com fundo americano.',
          author: 'Roberto Alves',
          section: 'Economia',
          priority: 'medium',
          style: 'body',
        },
      },
      {
        id: 'b5',
        type: 'article',
        x: 0, y: 12, w: 6, h: 4,
        content: {
          title: 'Festival de Cinema bate recorde de público',
          body: 'A 12ª edição do festival recebeu mais de 80 mil visitantes em cinco dias.',
          author: 'Ana Paula Rocha',
          section: 'Cultura',
          priority: 'medium',
          style: 'body',
        },
      },
      {
        id: 'b6',
        type: 'ad',
        x: 6, y: 12, w: 6, h: 4,
        content: {
          adName: 'AutoMax Veículos',
          adClient: 'AutoMax',
          imageUrl: 'https://readdy.ai/api/search-image?query=car%20dealership%20advertisement%20luxury%20vehicle%20showroom%20elegant%20minimal%20white%20background&width=600&height=300&seq=ad1&orientation=landscape',
        },
      },
    ],
  },
  {
    id: 'page-2',
    number: 2,
    type: 'interna',
    section: 'Política',
    status: 'aprovado',
    blocks: [
      {
        id: 'b7',
        type: 'title',
        x: 0, y: 0, w: 12, h: 1,
        content: { title: 'POLÍTICA', style: 'headline' },
      },
      {
        id: 'b8',
        type: 'article',
        x: 0, y: 1, w: 7, h: 8,
        content: {
          title: 'Governo estadual lança programa de habitação para 50 mil famílias',
          body: 'O governo estadual lançou ontem o programa Morar Bem, que prevê a construção de 12 mil unidades habitacionais para atender 50 mil famílias de baixa renda na região metropolitana. O investimento total é de R$ 3,8 bilhões, com recursos federais e estaduais. A iniciativa é considerada a maior da história do estado.',
          author: 'Marcos Vieira',
          section: 'Política',
          priority: 'high',
          style: 'headline',
          imageUrl: 'https://readdy.ai/api/search-image?query=housing%20construction%20residential%20buildings%20urban%20development%20government%20program%20families%20aerial&width=700&height=400&seq=ed-img2&orientation=landscape',
        },
      },
      {
        id: 'b9',
        type: 'article',
        x: 7, y: 1, w: 5, h: 4,
        content: {
          title: 'Câmara aprova projeto de lei sobre transparência fiscal',
          body: 'Por 23 votos a 8, os vereadores aprovaram ontem o projeto que obriga a divulgação mensal de todas as despesas municipais.',
          author: 'Patricia Santos',
          section: 'Política',
          priority: 'medium',
          style: 'body',
        },
      },
      {
        id: 'b10',
        type: 'article',
        x: 7, y: 5, w: 5, h: 4,
        content: {
          title: 'Secretaria de Saúde anuncia campanha de vacinação',
          body: 'A campanha de vacinação contra influenza começa na próxima segunda-feira em todos os postos de saúde da cidade.',
          author: 'Juliana Costa',
          section: 'Saúde',
          priority: 'medium',
          style: 'body',
        },
      },
      {
        id: 'b11',
        type: 'ad',
        x: 0, y: 9, w: 12, h: 3,
        content: {
          adName: 'Banco Regional — Crédito Fácil',
          adClient: 'Banco Regional',
          imageUrl: 'https://readdy.ai/api/search-image?query=bank%20financial%20services%20advertisement%20professional%20elegant%20minimal%20clean%20design&width=1200&height=200&seq=ad2&orientation=landscape',
        },
      },
    ],
  },
  {
    id: 'page-3',
    number: 3,
    type: 'interna',
    section: 'Economia',
    status: 'rascunho',
    blocks: [
      {
        id: 'b12',
        type: 'title',
        x: 0, y: 0, w: 12, h: 1,
        content: { title: 'ECONOMIA', style: 'headline' },
      },
      {
        id: 'b13',
        type: 'article',
        x: 0, y: 1, w: 6, h: 7,
        content: {
          title: 'Startup local levanta R$ 15 milhões em rodada série A',
          body: 'A fintech jardel-cityense Credix fechou rodada de investimento com fundo americano, planejando expansão para cinco novos estados. A empresa foi fundada em 2022 e já conta com 45 mil clientes ativos.',
          author: 'Roberto Alves',
          section: 'Economia',
          priority: 'high',
          style: 'headline',
          imageUrl: 'https://readdy.ai/api/search-image?query=startup%20office%20modern%20technology%20team%20working%20computers%20investment%20growth%20fintech&width=600&height=400&seq=ed-img3&orientation=landscape',
        },
      },
      {
        id: 'b14',
        type: 'article',
        x: 6, y: 1, w: 6, h: 7,
        content: {
          title: 'Exportações regionais crescem 18% no primeiro trimestre',
          body: 'Os dados divulgados pela Câmara de Comércio mostram crescimento expressivo nas exportações de produtos agroindustriais e tecnológicos da região.',
          author: 'Diego Ferreira',
          section: 'Economia',
          priority: 'medium',
          style: 'body',
        },
      },
    ],
  },
  {
    id: 'page-4',
    number: 4,
    type: 'interna',
    section: 'Cultura',
    status: 'rascunho',
    blocks: [],
  },
];

export const mockTemplates = [
  {
    id: 'tpl-1',
    name: 'Capa Clássica',
    description: 'Manchete principal + foto grande + 2 chamadas',
    thumbnail: 'https://readdy.ai/api/search-image?query=newspaper%20front%20page%20classic%20layout%20editorial%20design%20print%20professional&width=200&height=280&seq=tpl1&orientation=portrait',
    category: 'capa',
  },
  {
    id: 'tpl-2',
    name: 'Capa Moderna',
    description: 'Grid de 3 colunas com foto de destaque',
    thumbnail: 'https://readdy.ai/api/search-image?query=modern%20newspaper%20layout%20grid%20design%20editorial%20print%20contemporary&width=200&height=280&seq=tpl2&orientation=portrait',
    category: 'capa',
  },
  {
    id: 'tpl-3',
    name: 'Página Interna 2 Col',
    description: 'Duas colunas com artigos e anúncio rodapé',
    thumbnail: 'https://readdy.ai/api/search-image?query=newspaper%20interior%20page%20two%20column%20layout%20editorial%20design%20print&width=200&height=280&seq=tpl3&orientation=portrait',
    category: 'interna',
  },
  {
    id: 'tpl-4',
    name: 'Página Interna 3 Col',
    description: 'Três colunas clássicas com sidebar',
    thumbnail: 'https://readdy.ai/api/search-image?query=newspaper%20three%20column%20layout%20editorial%20classic%20print%20design%20interior%20page&width=200&height=280&seq=tpl4&orientation=portrait',
    category: 'interna',
  },
  {
    id: 'tpl-5',
    name: 'Esportes',
    description: 'Layout dinâmico com foto grande e placar',
    thumbnail: 'https://readdy.ai/api/search-image?query=sports%20newspaper%20page%20layout%20editorial%20design%20football%20action%20photo&width=200&height=280&seq=tpl5&orientation=portrait',
    category: 'interna',
  },
  {
    id: 'tpl-6',
    name: 'Contracapa',
    description: 'Anúncio full-page ou resumo de edição',
    thumbnail: 'https://readdy.ai/api/search-image?query=newspaper%20back%20page%20layout%20editorial%20design%20advertisement%20full%20page&width=200&height=280&seq=tpl6&orientation=portrait',
    category: 'contracapa',
  },
];

export const mockImageLibrary = [
  {
    id: 'img-1',
    url: 'https://readdy.ai/api/search-image?query=city%20hall%20government%20building%20urban%20architecture%20dramatic%20sky%20editorial&width=800&height=600&seq=lib1&orientation=landscape',
    caption: 'Prefeitura Municipal',
    section: 'Política',
  },
  {
    id: 'img-2',
    url: 'https://readdy.ai/api/search-image?query=housing%20construction%20residential%20buildings%20urban%20development%20government&width=800&height=600&seq=lib2&orientation=landscape',
    caption: 'Construção habitacional',
    section: 'Política',
  },
  {
    id: 'img-3',
    url: 'https://readdy.ai/api/search-image?query=startup%20office%20modern%20technology%20team%20working%20computers%20investment&width=800&height=600&seq=lib3&orientation=landscape',
    caption: 'Startup Credix',
    section: 'Economia',
  },
  {
    id: 'img-4',
    url: 'https://readdy.ai/api/search-image?query=film%20festival%20cinema%20red%20carpet%20crowd%20lights%20celebration%20cultural&width=800&height=600&seq=lib4&orientation=landscape',
    caption: 'Festival de Cinema',
    section: 'Cultura',
  },
  {
    id: 'img-5',
    url: 'https://readdy.ai/api/search-image?query=rare%20orchid%20flower%20discovery%20tropical%20rainforest%20botanical%20research&width=800&height=600&seq=lib5&orientation=landscape',
    caption: 'Orquídea descoberta',
    section: 'Ciência',
  },
  {
    id: 'img-6',
    url: 'https://readdy.ai/api/search-image?query=brazilian%20football%20team%20training%20field%20green%20grass%20stadium%20crowd&width=800&height=600&seq=lib6&orientation=landscape',
    caption: 'Seleção Brasileira',
    section: 'Esportes',
  },
];

export const mockAds = [
  {
    id: 'ad-1',
    name: 'AutoMax Veículos',
    client: 'AutoMax',
    size: 'meia-página',
    imageUrl: 'https://readdy.ai/api/search-image?query=car%20dealership%20advertisement%20luxury%20vehicle%20showroom%20elegant%20minimal%20white&width=600&height=400&seq=adlib1&orientation=landscape',
    status: 'ativo',
  },
  {
    id: 'ad-2',
    name: 'Banco Regional — Crédito',
    client: 'Banco Regional',
    size: 'rodapé',
    imageUrl: 'https://readdy.ai/api/search-image?query=bank%20financial%20services%20advertisement%20professional%20elegant%20minimal%20clean&width=1200&height=200&seq=adlib2&orientation=landscape',
    status: 'ativo',
  },
  {
    id: 'ad-3',
    name: 'Supermercado Bom Preço',
    client: 'Bom Preço',
    size: 'quarto-página',
    imageUrl: 'https://readdy.ai/api/search-image?query=supermarket%20grocery%20store%20advertisement%20fresh%20food%20products%20colorful&width=400&height=400&seq=adlib3&orientation=squarish',
    status: 'ativo',
  },
  {
    id: 'ad-4',
    name: 'Universidade Jardel City',
    client: 'UJC',
    size: 'meia-página',
    imageUrl: 'https://readdy.ai/api/search-image?query=university%20college%20education%20advertisement%20campus%20students%20learning&width=600&height=400&seq=adlib4&orientation=landscape',
    status: 'pendente',
  },
];
